<div class="inner-container bg-white section-gap-lg">
  <div class="container">
    <div fxLayout='row wrap' fxLayoutAlign="center center">
      <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="80" fxFlex.lg="70" fxFlex.xl="70">
        <div fxLayout='row wrap' fxLayoutAlign="center center">
          <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50">
            <!-- <div class="form-img register-image">
            </div> -->
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="80" fxFlex.lg="70" fxFlex.xl="70" style="display: flex;">
              <!-- <div class="form-img sign-in-image">
              </div> -->
              <img src="/assets/images/gefrecon/Gefrecon.png" style="margin: auto;" >
            </div>
          </div>
            <div fxFlex.xs="100"  fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50">
                <mat-card class="sign-in-form form-margin">
                    <h4>{{'SIGN_IN.SIGN_IN' | translate}}</h4>
                    <form [formGroup]="form"*ngIf="!isLoggedIn" (ngSubmit)="onSubmit($event)">
                        <div class="mb-4">
                          <mat-form-field class="w-100">
                            <mat-label>{{'SIGN_IN.USER_OR_EMAIL' | translate}}</mat-label>
                            <input matInput type="text" name="username" formControlName="username" required>
                            <mat-error *ngIf="form.get('username').hasError('required')">{{'REGISTER.VALIDATORS.USERNAME' | translate}}</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="mb-4">
                          <mat-form-field class="w-100">
                            <mat-label>{{'SIGN_IN.PASSWORD.PASSWORD' | translate}}</mat-label>
                            <input matInput type="password" name="password" formControlName="password" required>
                            <mat-error *ngIf="form.get('password').hasError('required')">{{'REGISTER.VALIDATORS.USERNAME' | translate}}</mat-error>
                          </mat-form-field>
                        </div>
                        <!-- <div class="mb-3">
                          <mat-checkbox>{{'SIGN_IN.PASSWORD.REMEMBER' | translate}}</mat-checkbox>
                          <span fxFlex></span> <a [routerLink]="['/session/forgot-password']">{{'SIGN_IN.PASSWORD.FORGOT' | translate}}</a>
                        </div> -->
                        <button color="accent" type="submit" class="submit button-lg mb-3" mat-raised-button >{{'SIGN_IN.SIGN_IN_BUTTON' | translate}}</button>
                        <p>{{'SIGN_IN.NOT_HAVE_COUNT' | translate}} <a [routerLink]="['/auth/register']">{{'SIGN_IN.CLICK_NEW_COUNT' | translate}}</a></p> 
                    </form>
                  </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>